import {Component, input, output} from '@angular/core';
import {MdbRippleModule} from "mdb-angular-ui-kit/ripple";
import {MdbSidenavModule} from "mdb-angular-ui-kit/sidenav";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-sidenav-item',
    imports: [
        MdbRippleModule,
        MdbSidenavModule,
        RouterLink,
        RouterLinkActive,
        TranslateModule
    ],
    templateUrl: './sidenav-item.component.html',
    standalone: true,
    styleUrl: './sidenav-item.component.scss'
})
export class SidenavItemComponent {
  text = input.required<string>()
  link = input.required<string>()
  onClick = output()
}
